import React, { FunctionComponent } from "react";

import { FlexDirection, FlexGrow, Layout, SpacingSize } from "@multiweb/reactComponents";
import { composeQA } from "@multiweb/reactUtils";
import { QAProps } from "@multiweb/types/react";
import { NavigationSection } from "../../navigation";
import { MenuItem } from "../MenuItem";
import { ProfileItem } from "../ProfileItem";

export type FormItemComponentProps = {
    /** Identifikátor formuláře */
    formItemId: number;
    /** Sekce, ve které je položka vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
    /** Identifikátory profilů formuláře */
    profileIds?: readonly number[];
} & QAProps;

/**
 * Komponenta slouží jako položka menu reprezentující formulář.
 * Komponenta zobrazuje i jednotlivé profily – pokud jimi formulář disponuje.
 */
export const FormItemComponent: FunctionComponent<FormItemComponentProps> = ({ formItemId, section, profileIds, qa }) => (
    <Layout
        flexDirection={FlexDirection.column}
        flexGrow={FlexGrow.one}
    >
        <MenuItem {...{ formItemId, section, qa }} />
        <Layout
            spacingSizeLeft={SpacingSize.l}
            flexDirection={FlexDirection.column}
        >
            {profileIds && profileIds.map((profileId) => (
                <ProfileItem key={profileId} parentFormItemId={formItemId} {...{ profileId, section }} qa={composeQA(formItemId, qa)} />
            ))}
        </Layout>
    </Layout>
);
